import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Clock, ArrowLeft, Sparkles } from 'lucide-react';
import ModuleLayout from '../layouts/ModuleLayout';
import { getModuleByPath } from '../config/moduleConfig';
import { useBranding } from '../context/BrandingContext';

/**
 * Coming Soon Page
 * Displays a friendly "coming soon" message for features under development
 */
export default function ComingSoon() {
  const location = useLocation();
  const navigate = useNavigate();
  const module = getModuleByPath(location.pathname);
  const branding = useBranding();

  // Extract feature name from path
  const pathParts = location.pathname.split('/').filter(Boolean);
  const featureName = pathParts[pathParts.length - 1]
    ?.replace(/-/g, ' ')
    ?.replace(/\b\w/g, (l) => l.toUpperCase()) || 'This Feature';

  const handleGoBack = () => {
    if (module) {
      navigate(module.basePath);
    } else {
      navigate(-1);
    }
  };

  return (
    <ModuleLayout>
      <div className="flex items-center justify-center min-h-full p-6">
        <div className="max-w-md w-full text-center">
          {/* Icon */}
          <div className="mb-6 inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-violet-100 to-purple-100 rounded-full">
            <Clock className="w-10 h-10 text-violet-600" />
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-slate-900 mb-3">
            Coming Soon
          </h1>

          {/* Feature Name */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-violet-50 rounded-full mb-4">
            <Sparkles className="w-4 h-4 text-violet-600" />
            <span className="text-sm font-medium text-violet-700">
              {featureName}
            </span>
          </div>

          {/* Description */}
          <p className="text-slate-600 mb-8 leading-relaxed">
            We're working hard to bring you this feature.
            It will be available in an upcoming update.
            Stay tuned for more exciting features!
          </p>

          {/* Back Button */}
          <button
            onClick={handleGoBack}
            className="inline-flex items-center gap-2 px-6 py-3 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors font-medium"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>

          {/* Additional Info */}
          <div className="mt-8 p-4 bg-slate-50 rounded-lg border border-slate-200">
            <p className="text-xs text-slate-500">
              Have suggestions for this feature? Contact us at{' '}
              <a
                href={`mailto:${branding.supportEmail}`}
                className="text-violet-600 hover:underline"
              >
                {branding.supportEmail}
              </a>
            </p>
          </div>
        </div>
      </div>
    </ModuleLayout>
  );
}
